var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVortex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109,
    height: 85,
    fill: "none",
    viewBox: "-15 0 140 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#909599",
    d: "M7.55 35.188c2.805-7.623 11.051-11.457 18.997-9.7 20.708 4.58 36.357 4.562 56.945.119 8.27-1.785 16.773 2.506 19.277 10.57 3.592 11.572 7.62 26.842 5.763 32.123-3.135 8.916-104.39 9.541-107.998 0-2.186-5.785 2.773-21.576 7.017-33.112z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEC",
    d: "M7.55 27.783c2.805-7.623 11.051-11.457 18.997-9.7 20.708 4.58 36.357 4.562 56.945.119 8.27-1.785 16.773 2.506 19.277 10.57 3.592 11.572 7.62 26.842 5.763 32.123-3.135 8.916-104.39 9.541-107.998 0-2.186-5.786 2.773-21.576 7.017-33.112z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0063C3",
    fillRule: "evenodd",
    d: "M75.106 27.627c-4.917 1.362-12.187 2.225-20.297 2.225-8.111 0-15.381-.863-20.298-2.226 2.373 2.161 10.561 3.754 20.297 3.754 9.737 0 17.925-1.593 20.298-3.753z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#909599",
    fillRule: "evenodd",
    d: "M108.768 67.76c-12.97 5.382-32.462 8.805-54.257 8.805-21.797 0-41.29-3.423-54.259-8.805C5.316 77.592 27.684 85 54.51 85c26.827 0 49.194-7.408 54.258-17.24z",
    clipRule: "evenodd",
    style: {
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#909599",
    fillRule: "evenodd",
    d: "M97.845 67.24c-10.358 4.298-25.927 7.032-43.335 7.032s-32.976-2.735-43.335-7.033c4.045 7.853 21.91 13.77 43.335 13.77 21.426 0 39.29-5.917 43.335-13.77z",
    clipRule: "evenodd",
    style: {
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEC",
    fillRule: "evenodd",
    d: "M108.768 60.413c-12.97 5.382-32.462 8.805-54.257 8.805-21.797 0-41.29-3.423-54.259-8.805 5.064 9.832 27.432 17.24 54.258 17.24 26.827 0 49.194-7.408 54.258-17.24z",
    clipRule: "evenodd",
    style: {
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEC",
    fillRule: "evenodd",
    d: "M102.215 57.983c-11.403 4.732-28.541 7.741-47.705 7.741-19.163 0-36.301-3.01-47.704-7.74C11.258 66.626 30.924 73.14 54.51 73.14c23.586 0 43.252-6.514 47.705-15.158z",
    clipRule: "evenodd",
    style: {
      mixBlendMode: "lighten"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00AEEF",
    fillRule: "evenodd",
    d: "M18.092 10.244C20.75 2.57 29.02-1.199 37.01.34 49.332 2.71 59.46 2.72 71.695.445c8.317-1.547 16.844 2.667 19.203 10.774 2.285 7.85 4.324 16.677 3.142 20.037-.122.347-.445.677-.95.99C88.03 38.77 72.43 43.52 53.97 43.52c-18.824 0-34.674-4.94-39.407-11.663a1.692 1.692 0 0 1-.46-.719 8.515 8.515 0 0 1-.188-.345l.094.039c-1.083-3.966 1.42-12.898 4.083-20.588z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BFDCF8",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M82.55 13.67c-6.79 2.31-16.994 3.78-28.404 3.78s-21.614-1.47-28.403-3.781c2.65 4.223 14.36 7.405 28.403 7.405s25.752-3.182 28.403-7.405z",
    clipRule: "evenodd",
    style: {
      mixBlendMode: "lighten"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E5671",
    d: "M58.89 9.279c-.178.533-.593.947-1.187 1.362-1.068.71-2.73 1.244-4.451 1.244-1.662 0-3.324-.474-4.452-1.244-.593-.415-1.009-.83-1.187-1.362-.534-1.48 2.018-2.784 5.639-2.784 3.68 0 6.172 1.303 5.638 2.784z",
    opacity: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#094860",
    d: "M57.762 10.641c-1.068.71-2.73 1.244-4.451 1.244-1.662 0-3.324-.474-4.452-1.244 1.01-.533 2.612-.888 4.452-.888 1.84 0 3.383.355 4.451.888z",
    opacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVortex);
export default __webpack_public_path__ + "static/media/vortex.732ed8dd63e5afc14e9d73a925208afc.svg";
export { ForwardRef as ReactComponent };